module.exports = __webpack_public_path__ + "static/media/grouchoparrot.9d69be99.gif";